import { HelpPanel } from '@amzn/awsui-components-react';
import { useLocalizedText } from '../../hooks/localizedText';

const I18N = 'nonProfitReachOut.tips';

const TIPS = ['personal', 'specific', 'short', 'followUp'] as const;

/**
 * "Tips to improve your message", shown in the AppLayout tools slot and opened from the Reach out
 * panel. Same pattern as NonProfitSearchHelpPanel.
 */
export function ReachOutTipsHelpPanel() {
  const { t } = useLocalizedText(['nonprofits', 'translation']);
  return (
    <HelpPanel header={<h2>{t(`${I18N}.title`)}</h2>}>
      <p>{t(`${I18N}.intro`)}</p>
      <ul>
        {TIPS.map((tip) => (
          <li key={tip}>{t(`${I18N}.${tip}`)}</li>
        ))}
      </ul>
    </HelpPanel>
  );
}
